/*
 *
 * Hedera Wallet Connect
 *
 * Copyright (C) 2023 Hedera Hashgraph, LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 */
/**
 * Enum representing different Hedera network chain IDs.
 *
 * @see {@link https://github.com/hashgraph/hedera-improvement-proposal/blob/main/HIP/hip-820.md#specification | HIP-820 Specification}
 */
export var HederaChainId;
(function (HederaChainId) {
    HederaChainId["Mainnet"] = "hedera:mainnet";
    HederaChainId["Testnet"] = "hedera:testnet";
    HederaChainId["Previewnet"] = "hedera:previewnet";
    HederaChainId["Devnet"] = "hedera:devnet";
})(HederaChainId || (HederaChainId = {}));
